export default class ApiConstants {
  static PARSE_API_GATEWAY_URL: string | any =
    process.env.NEXT_PUBLIC_PARSE_SERVER_URL;
  static API_GATEWAY_URL: string | any = process.env.NEXT_PUBLIC_SERVER_URL;

  static API_UMS_GATEWAY_URL: string | any =
    process.env.NEXT_PUBLIC_UMS_SERVER_URL;

  static API_AUTH_TOKEN: string = "";

  static API_PREFIX: string = "/";

  static PARSE_API_PREFIX: string = "/parse";

  static COINS_APPLICATION_KEY: string | any =
    process.env.NEXT_PUBLIC_COINS_APPLICATION_KEY;

  static COINS_JAVASCRIPT_KEY: string | any =
    process.env.NEXT_PUBLIC_COINS_JAVASCRIPT_KEY;

  static PROJECT_ID_HEADER_KEY = "Project-Code";
  /* static PROJECT_ID = process.env.NEXT_PUBLIC_PROJECT_CODE; */
  static PROJECT_ID: string | any = process.env.NEXT_PUBLIC_PROJECT_CODE;
  // static COUNTRY_CODE = "91";
  //static country_code_list = ["50", "52", "54", "55", "56", "58"];
  //static country_code_list = ["98", "99", "95", "80", "88", "9", "8"];
  static COUNTRY_CODE = process.env.NEXT_PUBLIC_COUNTRY_CODE;
  static apiKey = process.env.NEXT_PUBLIC_X_API_KEY;
  static country_code_list = [];

  static ENV_VAR = process.env.NEXT_PUBLIC_ENV;
  static IS_PRODUCTION = process.env.NEXT_PUBLIC_ENV === "PRODUCTION";
  static X_TIMEZONE_OFFSET = "X-Timezone-Offset";
  static X_TIMEZONE = "X-Timezone";

  static X_Api_Key = "X-Api-Key";
  static X_LANGUAGE = "x-language";

  static CountryCode = 101;

  //static RECAPTCHA_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
  static RECAPTCHA_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_KEY ?? "";

  static THRIWE_UMS_API_URL = process.env.NEXT_PUBLIC_THRIWE_UMS_URL ?? "";
  static THRIWE_DISCOVERY_API_URL =
    process.env.NEXT_PUBLIC_THRIWE_DISCOVERY_URL ?? "";
  static THRIWE_RMS_API_URL = process.env.NEXT_PUBLIC_THRIWE_RMS_URL ?? "";
  static THRIWE_FEEDBACK_API_URL =
    process.env.NEXT_PUBLIC_THRIWE_FEEDBACK_URL ?? "";
  static X_USER_REGION = "x-user-region";
}
